import AdminDashboardTab from '@/components/admin/AdminDashboardTab';
import MerchantManagementTab from '@/components/admin/MerchantManagementTab';
import OrderManagementTab from '@/components/admin/OrderManagementTab';
import CredentialsTab from '@/components/admin/CredentialsTab';
import TransfersTab from '@/components/admin/TransfersTab';
import WalletsTab from '@/components/admin/WalletsTab';
import ProductionConfigTab from '@/components/admin/ProductionConfigTab';
import ApiConnectionsTab from '@/components/admin/ApiConnectionsTab';
import LogsTab from '@/components/admin/LogsTab';
import MerchantApiLogsTab from '@/components/admin/MerchantApiLogsTab';
import SandboxTab from '@/components/admin/SandboxTab';
import AdminTransferTab from '@/components/admin/AdminTransferTab';
import AlliancesTab from '@/components/admin/AlliancesTab';
import ExpiredRefundsTab from '@/components/admin/ExpiredRefundsTab';
import PaymentVerifierTab from '@/components/admin/PaymentVerifierTab';
import LedgerTab from '@/components/admin/LedgerTab';
import CongregationsAuditTab from '@/components/admin/CongregationsAuditTab';

/**
 * Renders the appropriate tab body based on `activeTab`. Acts as a single
 * routing layer so SuperAdmin.jsx doesn't need to know about each tab module.
 */
export default function SuperAdminTabContent({
  activeTab, data, orderFilters, setOrderFilters, setToast,
}) {
  const {
    stats, merchants, logs, credentials, apiConnections, prodConfig,
    wallets, orders, transferConfig, transfers, serverInfo, exchangeRate,
    setExchangeRate, reload,
  } = data;

  switch (activeTab) {
    case 'dashboard':
      return stats ? (
        <AdminDashboardTab
          stats={stats} serverInfo={serverInfo} exchangeRate={exchangeRate}
          setExchangeRate={setExchangeRate} setToast={setToast} onReload={reload}
        />
      ) : null;
    case 'merchants':
      return <MerchantManagementTab merchants={merchants} setToast={setToast} onReload={reload} />;
    case 'ledger':
      return <LedgerTab setToast={setToast} />;
    case 'congregations':
      return <CongregationsAuditTab setToast={setToast} />;
    case 'logs':
      return <LogsTab logs={logs} />;
    case 'merchant-api-logs':
      return <MerchantApiLogsTab />;
    case 'api-connections':
      return <ApiConnectionsTab apiConnections={apiConnections} setToast={setToast} onReload={reload} />;
    case 'production':
      return <ProductionConfigTab prodConfig={prodConfig} onReload={reload} setToast={setToast} />;
    case 'commission-wallets':
      return <WalletsTab wallets={wallets} activeSubTab="commission-wallets" setToast={setToast} />;
    case 'wallets':
      return <WalletsTab wallets={wallets} activeSubTab="wallets" setToast={setToast} />;
    case 'orders':
      return (
        <OrderManagementTab
          orders={orders} merchants={merchants}
          orderFilters={orderFilters} setOrderFilters={setOrderFilters}
          onReload={reload} setToast={setToast}
        />
      );
    case 'credentials':
      return <CredentialsTab credentials={credentials} onReload={reload} setToast={setToast} />;
    case 'transfers':
      return <TransfersTab transferConfig={transferConfig} transfers={transfers} onReload={reload} setToast={setToast} />;
    case 'admin-transfer':
      return <AdminTransferTab setToast={setToast} />;
    case 'expired-refunds':
      return <ExpiredRefundsTab setToast={setToast} />;
    case 'payment-verifier':
      return <PaymentVerifierTab setToast={setToast} />;
    case 'alliances':
      return <AlliancesTab setToast={setToast} />;
    case 'sandbox':
      return <SandboxTab setToast={setToast} />;
    default:
      return null;
  }
}
